export default __webpack_public_path__ + "static/media/Arrow-Down-2.de617a11.svg";